var $ = require('jquery');
require('jquery-easing');

$( document ).on('click', '[data-scrollto]', function(evt) {
	var target_query = $(evt.currentTarget).attr('data-scrollto');
	$(window).trigger('scrollto', [target_query]);
	evt && evt.preventDefault();
	var speed = 1000;
	if ( $(evt.currentTarget).attr('data-scrollto-speed') ){
		speed = parseInt( $(evt.currentTarget).attr('data-scrollto-speed'), 10 );
	}
	if ( $(target_query).length == 0 ) {
		console.log('scrollto target : ' + target_query + ' not found');
		return;
	}
	var targetY = $(target_query).offset().top;
	console.log('targetY', targetY);
	targetY = Math.max(0, Math.min(targetY, $('body').height() - $(window).height()));
	console.log('targetY', targetY);
	$(window).trigger('scrollto:start', evt.currentTarget);
	$('html, body').animate({scrollTop:targetY}, speed, 'easeInOutQuart', function(){
		$(window).trigger('scrollto:end', evt.currentTarget);
	});
});



